module.exports = __webpack_public_path__ + "static/tablet-0f1c29cd97ff5332e77fc2d1ffd64bb2.webp";